import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import authRepository from '../repositories/authRepository';
import { getPostLoginPath } from './getPostLoginPath';
import { UserRepository } from '../repositories/userRepository';
import { login } from '../store/authSlice';
import { setUser } from '../store/userSlice';
import { useEffectEventHook } from '../hooks/useEffectEventHook';

// A restored session leaves these entry pages for the user's home page.
const signedOutEntryPaths = ['/login', '/signup', '/'];

/** Restores the saved Firebase session into the store once, after Firebase has loaded it. */
export function useAuthBootstrap() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const restoreSession = useEffectEventHook(async () => {
    await authRepository.waitForAuthReady();
    const redirectUser = await getGoogleRedirectUser();
    const firebaseUser = redirectUser ?? authRepository.getAuth().currentUser;
    if (!firebaseUser) {
      return;
    }

    const userData = await UserRepository.getUserDetails(firebaseUser.uid);
    dispatch(setUser(userData?.toJson()));
    dispatch(login(authRepository.parseUser(firebaseUser)));

    if (redirectUser || signedOutEntryPaths.includes(window.location.pathname)) {
      navigate(getPostLoginPath(userData?.toJson()));
    }
  });

  useEffect(() => {
    restoreSession()
      .catch((error) => console.error('Error restoring the signed-in session:', error));
  }, [restoreSession]);
}

async function getGoogleRedirectUser() {
  // Development signs in with a popup, so there is never a redirect result to read.
  if (process.env.NODE_ENV === 'development') {
    return null;
  }
  return authRepository.handleGoogleRedirectResult();
}
